module.exports = __webpack_public_path__ + "static/media/LogoBlack.5b5b8fd3.svg";